// NOTE: Must match the backend API defined in models/metric_diff.rb

export enum Period {
  LastWeek = 'last_week',
  Last2Weeks = 'last_2_weeks',
  LastMonth = 'last_month',
  Last2Months = 'last_2_months',
  Last3Months = 'last_3_months',
  Last6Months = 'last_6_months',
  LastYear = 'last_year',
}
